import * as Messaging from "./Messaging/index.js";
import * as AddListing from "./AddListing/index.js";
import * as RegisterUser from "./RegisterUser/index.js";
import * as Shapes from "./Shapes/index.js";
/** CoStar.Api.AptsNet.Aggregate.ViewModels.ImageSize */
export var ImageSize;
(function (ImageSize) {
    ImageSize[ImageSize["Unknown"] = 0] = "Unknown";
    ImageSize[ImageSize["Master"] = 1] = "Master";
    ImageSize[ImageSize["Small"] = 4] = "Small";
    ImageSize[ImageSize["Thumbnail"] = 5] = "Thumbnail";
    ImageSize[ImageSize["Edit"] = 6] = "Edit";
    ImageSize[ImageSize["Enlarge"] = 7] = "Enlarge";
    ImageSize[ImageSize["Large"] = 10] = "Large";
    ImageSize[ImageSize["ExtraLarge"] = 11] = "ExtraLarge";
    ImageSize[ImageSize["HighDefinition"] = 12] = "HighDefinition";
    ImageSize[ImageSize["Widescreen"] = 13] = "Widescreen";
    ImageSize[ImageSize["GoLarge"] = 14] = "GoLarge";
    ImageSize[ImageSize["GoDetail"] = 15] = "GoDetail";
    ImageSize[ImageSize["GoLargeHighDefinition"] = 16] = "GoLargeHighDefinition";
    ImageSize[ImageSize["GoDetailHighDefinition"] = 17] = "GoDetailHighDefinition";
    ImageSize[ImageSize["GoThumbnailHighDefinition"] = 18] = "GoThumbnailHighDefinition";
    ImageSize[ImageSize["FusionDetailSmall"] = 19] = "FusionDetailSmall";
})(ImageSize || (ImageSize = {}));
import { DynamicLeadFormType } from "../../../../../CoStar/Api/AptsListings/ViewModels/index.js";
/** CoStar.Api.AptsNet.Aggregate.ViewModels.DynamicLeadFormType */
export { DynamicLeadFormType };
/** CoStar.Api.AptsNet.Aggregate.ViewModels.ForRentSignType */
export var ForRentSignType;
(function (ForRentSignType) {
    ForRentSignType[ForRentSignType["None"] = 0] = "None";
    ForRentSignType[ForRentSignType["YardSign"] = 1] = "YardSign";
    ForRentSignType[ForRentSignType["WindowSign"] = 2] = "WindowSign";
    ForRentSignType[ForRentSignType["FenceSign"] = 3] = "FenceSign";
    ForRentSignType[ForRentSignType["OpenMarket"] = 4] = "OpenMarket";
})(ForRentSignType || (ForRentSignType = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.AmenityTypes */
export var AmenityTypes;
(function (AmenityTypes) {
    AmenityTypes[AmenityTypes["None"] = 0] = "None";
    AmenityTypes[AmenityTypes["SmokeFree"] = 1] = "SmokeFree";
    AmenityTypes[AmenityTypes["WasherDryer"] = 2] = "WasherDryer";
    AmenityTypes[AmenityTypes["Dishwasher"] = 4] = "Dishwasher";
    AmenityTypes[AmenityTypes["Heating"] = 8] = "Heating";
    AmenityTypes[AmenityTypes["AirConditioning"] = 16] = "AirConditioning";
    AmenityTypes[AmenityTypes["Balcony"] = 32] = "Balcony";
    AmenityTypes[AmenityTypes["Fireplace"] = 64] = "Fireplace";
    AmenityTypes[AmenityTypes["Furnished"] = 128] = "Furnished";
    AmenityTypes[AmenityTypes["Gym"] = 256] = "Gym";
    AmenityTypes[AmenityTypes["Pool"] = 512] = "Pool";
    AmenityTypes[AmenityTypes["TennisCourt"] = 1024] = "TennisCourt";
    AmenityTypes[AmenityTypes["RoofTerrace"] = 2048] = "RoofTerrace";
    AmenityTypes[AmenityTypes["BasketballCourt"] = 4096] = "BasketballCourt";
    AmenityTypes[AmenityTypes["Playground"] = 8192] = "Playground";
    /** @deprecated Please use PricingTools.RentSpecial instead. */
    AmenityTypes[AmenityTypes["RentSpecials"] = 16384] = "RentSpecials";
    AmenityTypes[AmenityTypes["GarageParking"] = 32768] = "GarageParking";
    AmenityTypes[AmenityTypes["WheelchairAccess"] = 65536] = "WheelchairAccess";
    AmenityTypes[AmenityTypes["Parking"] = 131072] = "Parking";
    AmenityTypes[AmenityTypes["HighSpeedInternet"] = 262144] = "HighSpeedInternet";
    AmenityTypes[AmenityTypes["Elevator"] = 524288] = "Elevator";
    AmenityTypes[AmenityTypes["WasherDryerHookup"] = 1048576] = "WasherDryerHookup";
    AmenityTypes[AmenityTypes["LaundryFacilities"] = 2097152] = "LaundryFacilities";
    AmenityTypes[AmenityTypes["Gated"] = 4194304] = "Gated";
})(AmenityTypes || (AmenityTypes = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.RecommendationExclusionTypes */
export var RecommendationExclusionTypes;
(function (RecommendationExclusionTypes) {
    RecommendationExclusionTypes[RecommendationExclusionTypes["None"] = 0] = "None";
    RecommendationExclusionTypes[RecommendationExclusionTypes["Favorites"] = 1] = "Favorites";
    RecommendationExclusionTypes[RecommendationExclusionTypes["Viewed"] = 2] = "Viewed";
    RecommendationExclusionTypes[RecommendationExclusionTypes["Hidden"] = 4] = "Hidden";
})(RecommendationExclusionTypes || (RecommendationExclusionTypes = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.SubmarketOverlayItemType */
export var SubmarketOverlayItemType;
(function (SubmarketOverlayItemType) {
    SubmarketOverlayItemType[SubmarketOverlayItemType["Unknown"] = 0] = "Unknown";
    SubmarketOverlayItemType[SubmarketOverlayItemType["Submarket"] = 1] = "Submarket";
    SubmarketOverlayItemType[SubmarketOverlayItemType["SubmarketCluster"] = 2] = "SubmarketCluster";
})(SubmarketOverlayItemType || (SubmarketOverlayItemType = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.UserPasswordResetError */
export var UserPasswordResetError;
(function (UserPasswordResetError) {
    UserPasswordResetError[UserPasswordResetError["None"] = 0] = "None";
    UserPasswordResetError[UserPasswordResetError["PasswordLacksComplexity"] = 1] = "PasswordLacksComplexity";
    UserPasswordResetError[UserPasswordResetError["TokenIsInvalid"] = 2] = "TokenIsInvalid";
    UserPasswordResetError[UserPasswordResetError["EmailDoesNotExists"] = 3] = "EmailDoesNotExists";
})(UserPasswordResetError || (UserPasswordResetError = {}));
/** CoStar.Api.AptsNet.Aggregate.ViewModels.CommuteTravelMode */
export var CommuteTravelMode;
(function (CommuteTravelMode) {
    CommuteTravelMode[CommuteTravelMode["Unknown"] = 0] = "Unknown";
    CommuteTravelMode[CommuteTravelMode["Car"] = 1] = "Car";
    CommuteTravelMode[CommuteTravelMode["PublicTransit"] = 2] = "PublicTransit";
    CommuteTravelMode[CommuteTravelMode["Bike"] = 3] = "Bike";
    CommuteTravelMode[CommuteTravelMode["Walk"] = 4] = "Walk";
})(CommuteTravelMode || (CommuteTravelMode = {}));
export { Messaging, AddListing, RegisterUser, Shapes };
